import { MonoMeta, StateWord } from "@/design/primitives";

// The live feed's one row — a real state flip, in plain words, with how long
// ago it happened. Lifted out of the Desk (4→2 council, 2026-10-22) so the
// In Flight feed reads the same grammar the Desk already speaks.
export const kindWord = {
  moved: "moved",
  progress: "moved",
  resolved: "fixed",
  picked_up: "started",
  needs_you: "needs you",
  finished: "finished",
  failed: "failed",
  beat: "beat",
};

export const kindTone = {
  resolved: "green",
  finished: "green",
  picked_up: "green",
  needs_you: "amber",
  failed: "red",
  moved: "muted",
  progress: "muted",
  beat: "muted",
};

export const ago = (at) => {
  const d = new Date(at || "");
  if (Number.isNaN(d.getTime())) return "";
  const mins = Math.max(0, Math.round((Date.now() - d.getTime()) / 60000));
  if (mins < 1) return "just now";
  if (mins < 60) return `${mins} min ago`;
  if (mins < 1440) return `${Math.round(mins / 60)} hr ago`;
  return d.toLocaleDateString("en-US", { month: "short", day: "numeric" });
};

export const EventRow = ({ e, testId = "desk-event-row", deskAnim }) => (
  <li
    data-testid={testId}
    className={
      "flex items-baseline gap-3 rounded-card border border-os-border px-4 py-2.5" +
      (deskAnim ? " desk-slide-in" : "")
    }
  >
    <StateWord tone={kindTone[e.kind] || "muted"}>
      {kindWord[e.kind] || e.kind}
    </StateWord>
    <p className="min-w-0 flex-1 truncate text-[0.875rem] text-os-ink">
      {e.title}
    </p>
    <MonoMeta as="p" className="shrink-0">
      {ago(e.at)}
    </MonoMeta>
  </li>
);

export default EventRow;
